module.exports = __webpack_public_path__ + "img/product-shot_04_loading.3f3d23aa.jpg";